import React from 'react';
import { Navigate } from 'react-router-dom';
import RegisterPage from '../../features/auth/pages/RegisterPage';
import LoginPage from '../../features/auth/pages/LoginPage';

export const publicRoutes = [
  { path: '/', element: <Navigate to="/login" /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/login', element: <LoginPage /> },
];
